import React from 'react';
import {
    SignupNameSection,
    NameBlock,
    TitleWrapper,
    TitleTxt,
    TitleNote,
    NameInputBlock,
    InputStyle,
    DeleteButton,
    DeleteIcon,
    ErrorBlock,
    ErrorIcon,
    ErrorMessage
} from './style'
import warningIcon from 'images/warning.png';
import cancelIcon from 'images/icon/close_btn_grey_circle-18x18.png';

const SignupNameScene = ({
    name,
    onChange,
    errorMsg,
}) => {
    const errClassName = errorMsg ? 'error_active' : null
    return (
        <SignupNameSection>
            <NameBlock>
                <TitleWrapper>
                    <TitleTxt>
                        {'이름을 \n 입력해 주세요'}
                    </TitleTxt>
                    <TitleNote>(기업 담당자만 확인 가능)</TitleNote>
                </TitleWrapper>
                <NameInputBlock>
                    <InputStyle className={errClassName} onChange={(e)=>{if(onChange)onChange(e.target.value)}} value={name} maxLength="50" placeholder='이름을 입력해 주세요' />
                    {(name?.length && name.length >= 2) ? (
                        <DeleteButton onClick={() =>{if(onChange)onChange('');}}>
                            <DeleteIcon src={cancelIcon} />
                        </DeleteButton>
                    ) : null}
                </NameInputBlock>
            </NameBlock>
            {errorMsg ? (
                <ErrorBlock>
                    <ErrorIcon src={warningIcon} />
                    <ErrorMessage>{errorMsg}</ErrorMessage>
                </ErrorBlock>
            ) : null}
            
        </SignupNameSection> 
    );
}

export default SignupNameScene;